import { useTranslation } from 'react-i18next';
import type { Token } from '../../@types/Token';
import useAuth from '../../hooks/useAuth';
import Alert from '../../styled-components/components/Alert';
import { Button } from '../../styled-components/components/Button';
import Container from '../../styled-components/components/Container';
import { StackMedium } from '../../styled-components/components/Stack';
import { getMarket } from '../../utils/market';

export const isWrongMarket = (decodedToken?: Token) => {
  if (!decodedToken) return false;
  const marketCodeToken = decodedToken['market-code'] ?? 'SE';
  const marketCode = getMarket()?.marketCode ?? 'SE';
  return marketCodeToken !== marketCode;
};

const ns = 'authentication';

const WrongMarket = () => {
  const { t } = useTranslation(ns);
  const { signOut } = useAuth();

  return (
    <Container>
      <StackMedium>
        <Alert
          tone="error"
          heading={t('wrongMarket.heading', { ns })}
          message={t('wrongMarket.message', {
            ns,
          })}
        />
      </StackMedium>
      <StackMedium>
        <Button $tone="secondary" onClick={signOut} title={t('wrongMarket.signOut', { ns })}>
          {t('signOut', { ns })}
        </Button>
      </StackMedium>
    </Container>
  );
};
export default WrongMarket;
